// extracted by mini-css-extract-plugin
export default {"centeredWrapper":"loadable-virtual-table_centeredWrapper__nMfsV","centered":"loadable-virtual-table_centered__w28Qb","scrollable":"loadable-virtual-table_scrollable__+9UbR"};